var arrayCleanup = function() {
  return function(input) {
    if(input == null) { return }
    return input.toString().replace(/,/gi, ', ')
  };
};

arrayCleanup.$inject = [];
tiz.filter('arrayCleanup', arrayCleanup);
